export default __webpack_public_path__ + "static/media/paypal.eecfc493.svg";